<template>
	<div>
		<div class="title">
			<div class="title-name">Create Expense</div>
			<div class="title-desc" @click="onStayOrBack()">
				&lt;&nbsp;<span>Back to Expenses</span>
			</div>
		</div>
		<div class="dropzone" @drop.prevent="dropFile" @dragover.prevent>
			<Upload v-if="!$vuetify.breakpoint.smAndDown" color="#C4C4C4"/>
			<div class="dropzone-text" :class="!$vuetify.breakpoint.smAndDown? 'ml-7':'mx-5'">
				<div v-if="!$vuetify.breakpoint.smAndDown" class="dropzone-drag">Drag and drop</div>
				<div v-if="!$vuetify.breakpoint.smAndDown" class="dropzone-desc">File types accepted: JPG, JPEG, PNG, PDF,Maximum size &nbsp;<span>{{ max_file_size}}</span>&nbsp;MB</div>
				<div v-if="$vuetify.breakpoint.smAndDown" class="dropzone-desc">
					<div>File types accepted: JPG, JPEG, PNG, PDF,</div>
					<div>Maximum size &nbsp;<span>{{ max_file_size}}</span>&nbsp;MB</div>
				</div>
				<div :class="`mt-2 ${$vuetify.breakpoint.smAndDown ? 'dropzon-button-sm':'dropzon-button'}`" >
					<v-btn depressed color="#00AAFD" class="text-capitalize white--text" :class="$vuetify.breakpoint.smAndDown ? 'my-3':'mr-3'" @click="onUploadReceipt()">
						<Upload v-if="!$vuetify.breakpoint.smAndDown" width="18" height="18" color="#FFFFFF" class="mr-1"/>
						Upload Receipt
					</v-btn>
					<v-btn depressed color="#00AAFD" class="text-capitalize white--text" @click="onCreateExpenseWithoutReceipt()">
						<v-icon v-if="!image_loading" color="#FFFFFF" class="mr-1">mdi-plus</v-icon>
						<v-progress-circular v-if="image_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
						Expense (without Receipt)
					</v-btn>
				</div>
			</div>
			<input type="file" class="hidden" ref="updateFile" :accept="file_type.join(',')" capture @change="e => update_files(e)"/>
			<input type="file" class="hidden" ref="capture" :accept="file_type.join(',')" capture multiple @change="e => capture_files(e)"/>
		</div>
		<v-alert type="error" class="mx-5 mt-5 mb-0" v-if="error_msg.length !== 0">{{
			error_msg
		}}</v-alert>
		<v-row v-if="$vuetify.breakpoint.width <= 1600" no-gutters class="receipt-container">
			<v-row v-for="(receipt, index) in receipts" :key="`${index}_${receipt.id}`" class="ma-1">
				<NewEditReceipt
					ref="newReceiptComponents"
					class="receipt-container-item" 
					:color="color" 
					:currencies="currencies" 
					:receipt="receipt"
					:isShowMarkup="isShowMarkup"
					:isEditMarkup="isEditMarkup"
					@save="save_entry($event)"
					@delete="delete_entry($event)"
					@add-file="onAddFile($event)"
					@del-file="onDelFile($event)"
				/>
			</v-row>
		</v-row>
		<v-row v-else no-gutters class="receipt-container">
			<v-col v-for="(receipt, index) in receipts" cols="6" :key="`${index}_${receipt.id}`">
				<NewEditReceipt
					ref="newReceiptComponents"
					class="receipt-container-item" 
					:color="color" 
					:currencies="currencies" 
					:receipt="receipt"
					:isShowMarkup="isShowMarkup"
					:isEditMarkup="isEditMarkup"
					@save="save_entry($event)"
					@delete="delete_entry($event)"
					@add-file="onAddFile($event)"
					@del-file="onDelFile($event)"
				/>
			</v-col>
		</v-row>
		<LeaveReceiptsDialog
			v-if="leave_dialog || receipts_leave_dialog"
			:visible="leave_dialog || receipts_leave_dialog"
			:type="'warning'"
			:title_text="`You have unsaved receipts!`"
			:content_text="`Save receipts before leaving this page?`"
			:cancel_button="`No, leave`"
			:confirm_button="`Save receipts`"
			@cancel="onDelAllReceipts()"
			@ok="onSaveAllReceipts()"
		/>
		<LeaveReceiptsDialog
			v-if="upload_dialog"
			:visible="upload_dialog"
			:title_text="`Upload successful`"
			:content_text="`Do you want to upload more?`"
			:cancel_button="`Yes`"
			:confirm_button="`No, thanks `"
			@cancel="upload_dialog = false"
			@ok="onBack()"
		/>
	</div>
</template>

<script>
import heic2any from 'heic2any';

import Upload from "@/components/icons/upload";
import NewEditReceipt from "@/views/expenses/receipts/edit_receipt";
import LeaveReceiptsDialog from "@/components/expenses/leave_receipts_dialog";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const MAX_FILE_SIZE = 6;
const MAX_SIZE = 1000;
const QUALITY = 0.5;
const FILE_TYPE = ['image/jpeg','image/png','image/heic','image/heic-sequence','application/pdf'];
const SCALE = 1.2;

/** If ticked the user can see markups configured in the system */
const MUVW = 'MUvw';
/** If ticked the user can modify markups configured in the system */
const MUAM = 'MUam';

export default {
	props: {
		color: {
			type: String,
			default: '#00AAFD',
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		receipts_leave_dialog: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			max_file_size: MAX_FILE_SIZE,
			file_type: FILE_TYPE,
			error_msg: '',
			
			receipts: [],
			upload_image_receipt: null,
			upload_dialog: false,
			leave_dialog: false,
			image_loading: false,
		}
	},
	created() {
		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Upload Receipt",
			to: this.$route.path
		});
	},
	components: {
		Upload,
		NewEditReceipt,
		LeaveReceiptsDialog,
	},
	watch: {
		receipts() {
			this.$emit('receipts', this.receipts.length);
		}
	},
	computed: {
		isShowMarkup() {
			let is_show_markup = false;

			if (this.$store.state.privileges.length !== 0) {
				is_show_markup = this.$store.state.privileges.includes(MUVW) ? true : false;
			}

			return is_show_markup;
		},
		isEditMarkup() {
			let is_edit_markup = false;

			if (this.$store.state.privileges.length !== 0) {
				is_edit_markup = this.$store.state.privileges.includes(MUAM) ? true : false;
			}

			return is_edit_markup;
		},
	},
	methods: {
		onCreateExpenseWithoutReceipt() {
			if (this.image_loading) {
				return;
			}

			this.image_loading = true;

			const blob = new Blob([''], {type : 'image/jpeg'});
			const url = "/api/expenses/receipts";

			axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const receipt = this._getReceiptObj(data);

						this.receipts.push(receipt);						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.image_loading = false;
				});
		},
		onAddFile(receipt) {
			this.upload_image_receipt = receipt;
			this.$refs.updateFile.click();
		},
		onDelFile(receipt) {
			const url = `/api/expenses/receipts/${receipt.id}/image`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.receipts.forEach(receipt => {
							if (receipt.id === data.id) {
								receipt.image = data.image === null ? '' : data.image;
								receipt.image_type = data.image_type;
								receipt.loading = false;
							}
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		dropFile(event) {
			let droppedFiles = event.dataTransfer.files;
			if (!droppedFiles) {
				return
			}

			([...droppedFiles]).forEach(file => {
				this.add_receipt_for_file(file, true);
			})
		},
		onUploadReceipt() {
			// Thanks to https://stackoverflow.com/questions/16215771/how-to-open-select-file-dialog-via-js and https://blog.addpipe.com/correct-syntax-html-media-capture/
			this.error_msg = '';
			this.$refs.capture.click();
		},
		capture_files(e) {
			for (let i = 0; i < e.target.files.length; i++) {
				this.add_receipt_for_file(e.target.files[i], true);
			}
		},
		update_files(e) {
			const file = e.target.files[0];
			this.add_receipt_for_file(file, false);
		},
		add_loading_receipt() {
			const receipt = {
				id: 0,
				employee: null,
				desc: '',
				date: new Date().toISOString().substr(0, 10),
				currency: null,
				thumbnail: '',
				image: '',
				image_type: '',
				ocr: null,
				value: 0,
				has_tax: true,
				tax_mode: 0,
				tax_perc: 0,
				tax_amount: 0,
				markup_perc: 0,
				markup_value: 0,
				job: null,
				phase: null,
				kind: null,
				is_used: false,
				loading: true
			};

			this.receipts.push(receipt);
			return receipt;
		},
		remove_loading_receipt(receipt) {
			const index = this.receipts.indexOf(receipt);
			if (index !== -1) {
				this.receipts.splice(index, 1);
			}
		},
		add_receipt_for_file(file, isAdd) {
			if (!file) {
				return;
			}
			if (!this.file_type.includes(file.type)) {
				this.error_msg = `File: ${file.name}, invalid file type`;
				return;
			}
			if (file.size > 1000 * 1000 * MAX_FILE_SIZE) {
				this.error_msg = `File: ${file.name}, over maximum ${MAX_FILE_SIZE}MB size`;
				return;
			}

			const loading_receipt = isAdd ? this.add_loading_receipt() : null;

			console.log('file-before-size:', file.size/1024, 'kb');

			const reader = new FileReader();
			reader.readAsDataURL(file); 

			if (file.type === 'application/pdf') {
				reader.onload = readerEvent =>  {
					const pdf_data = readerEvent.target.result;
					const preview_url = [];

					const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
					loadingTask.promise.then(pdf => {
						for (let index = 0; index < pdf.numPages; index++) {
							pdf.getPage(index + 1).then(page => {
								const scale = SCALE;
								const viewport = page.getViewport({scale: scale});

								const canvas = document.createElement('canvas');
								const context = canvas.getContext('2d');
								canvas.width = viewport.width;
								canvas.height = viewport.height;

								const renderContext = {
									canvasContext: context,
									viewport: viewport
								};
								const renderTask = page.render(renderContext);
								renderTask.promise.then(() => {
									canvas.toBlob(blob => {
										const preview_item_url = URL.createObjectURL(blob);
										preview_url.push(preview_item_url);
									});									
								});
							});
						}
					});

					if (isAdd) {
						this.add_receipt_for_image(pdf_data, preview_url, loading_receipt);
					} else {
						const blob = this._dataURItoBlob(pdf_data);
						console.log('file-after-size:', blob.size /1024, 'kb');
						this.upload_receipt_for_image(blob, preview_url);
					}
				};
			} else if (file.type === 'image/heic' || file.type === 'image/heic-sequence') {
				heic2any({ blob: file, toType: 'image/jpeg' }).then((blob) => {
					reader.readAsDataURL(blob);

					const preview_url = URL.createObjectURL(blob);
					const image = new Image();
					
					reader.onload = readerEvent =>  {
						image.src = readerEvent.target.result;
						image.onload = () => {
							const resize_data = this._resizeByQuality(image, 1);

							if (isAdd) {
								this.add_receipt_for_image(resize_data, preview_url, loading_receipt);
							} else {
								const blob = this._dataURItoBlob(resize_data);
								console.log('file-after-size:', blob.size /1024, 'kb');
								this.upload_receipt_for_image(blob, preview_url);
							}
						}
					};
				}).catch((e) => {
					this.remove_loading_receipt(loading_receipt);
					this.error_msg = e.message;
				});
			} else {
				const preview_url = URL.createObjectURL(file);
				const image = new Image();

				reader.onload = readerEvent =>  {
					image.src = readerEvent.target.result;
					image.onload = () => {
						const resize_data = this._resizeByQuality(image, QUALITY);

						if (isAdd) {
							this.add_receipt_for_image(resize_data, preview_url, loading_receipt);
						} else {
							const blob = this._dataURItoBlob(resize_data);
							console.log('file-after-size:', blob.size /1024, 'kb');
							this.upload_receipt_for_image(blob, preview_url);
						}
					}
				};
			}
		},
		async add_receipt_for_image(data, preview_url, loading_receipt) {
			const url = "/api/expenses/receipts";
			const blob = this._dataURItoBlob(data);
			console.log('file-after-size:', blob.size /1024, 'kb');

			await axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const receipt = this._getReceiptObj(data, preview_url);

						const index = this.receipts.indexOf(loading_receipt);
						if (index !== -1) {
							this.$set(this.receipts, index, receipt);
						} else {
							this.receipts.push(receipt);
						}
					} else {
						this.remove_loading_receipt(loading_receipt);
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.remove_loading_receipt(loading_receipt);
					this.error_msg = e.message;
				});
		},
		upload_receipt_for_image(blob, preview_url) {
			this.receipts.forEach(receipt => {
				if (receipt.id === this.upload_image_receipt.id) {
					receipt.loading = true;
				}
			});
			
			const url = `/api/expenses/receipts/${this.upload_image_receipt.id}/image`;
			axios
				.put(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.receipts.forEach(receipt => {
							if (receipt.id === data.id) {
								receipt.image = preview_url;
								receipt.image_type = data.image_type;
								receipt.loading = false;
							}
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async save_entry(new_receipt) {
			if (new_receipt.id === 0) return;

			const url = "/api/expenses/receipts/" + new_receipt.id;

			await axios
				.put(url, new_receipt, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						let index_del = null;
						this.receipts.forEach((receipt, index) => {
							if (receipt.id === new_receipt.id) {
								index_del = index;
							}
						});
						this.receipts.splice(index_del, 1);
						if (this.receipts.length === 0) {
							this.upload_dialog = true;
						}

						if (this.leave_dialog && !this.receipts_leave_dialog && this.receipts.length === 0) {
							this.leave_dialog = false;
							this.$emit('receipts', this.receipts.length);
							this.onBack();
						}

						if (!this.leave_dialog && this.receipts_leave_dialog && this.receipts.length === 0) {
							this.upload_dialog = false;
							this.$emit('change-tab');
						} 

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		async delete_entry(receipt_id) {
			if (receipt_id === 0) return;

			const url = "/api/expenses/receipts/" + receipt_id;
			await axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason} = val.data;
					
					if (status == "OK") {
						let index_del = null;
						this.receipts.forEach((receipt,index) => {
							if (receipt.id === receipt_id) {
								index_del = index;
							}
						});
						this.receipts.splice(index_del, 1);

						if (this.leave_dialog && !this.receipts_leave_dialog && this.receipts.length === 0) {
							this.leave_dialog = false;
							this.$emit('receipts', this.receipts.length);
							this.onBack();
						}
						if (!this.leave_dialog && this.receipts_leave_dialog) {
							this.upload_dialog = false;
							this.$emit('change-tab');
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async onSaveAllReceipts() {
			await this.$nextTick();

			const receipt_refs = this.$refs.newReceiptComponents || [];
			const receipt_components = Array.isArray(receipt_refs) ? receipt_refs : [receipt_refs];
			const new_receipts = receipt_components.map(component => component.getReceiptValue());

			if (new_receipts.some(receipt => receipt === null)) {
				this.error_msg = 'Please complete all required receipt fields before saving.';
				return;
			}

			for (const new_receipt of new_receipts) {
				await this.save_entry(new_receipt);
			}
		},
		async onDelAllReceipts() {
			const receipts_arr = this.receipts;

			for await (const receipt of receipts_arr) {
				this.delete_entry(receipt.id);
			}
		},
		onStayOrBack() {
			if (this.receipts.length !== 0) {
				this.leave_dialog = true;
			} else {
				this.onBack();
			}
		},
		onBack() {
			this.upload_dialog = false;
			this.$emit('go-back');
		},
		_getReceiptObj(data, preview_url=null) {
			const receipt = {
				id: data.id,
				employee: data.employee,
				desc: data.desc,
				date: data.date,
				currency: null,
				thumbnail: data.thumbnail && data.thumbnail !== 'undefined' && data.thumbnail !== 'null' ? data.thumbnail : '',
				image: preview_url ? preview_url : (data.image && data.image !== 'undefined' && data.image !== 'null' ? data.image : ''),
				image_type: data.image_type,
				ocr: data.ocr,
				value: data.value,
				has_tax: data.has_tax,
				tax_mode: data.tax_mode,
				tax_perc: typeof(data.tax_perc) === 'string' ? Number(data.tax_perc) : data.tax_perc,
				tax_amount: typeof(data.tax_amount) === 'string' ? Number(data.tax_amount) : data.tax_amount,
				markup_perc: typeof(data.markup_perc) === 'string' ? Number(data.markup_perc) : data.markup_perc,
				markup_value: typeof(data.markup_value) === 'string' ? Number(data.markup_value) : data.markup_value,
				job: data.job,
				phase: data.phase,
				kind: data.kind,
				is_used: data.is_used,
				loading: false,
			};

			return receipt;
		},
		_dataURItoBlob(dataURI) {
			// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
			// convert base64 to raw binary data held in a string
			// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
			var byteString = atob(dataURI.split(',')[1]);

			// separate out the mime component
			var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to an ArrayBuffer
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ab], {type: mimeString});
		},
		_resizeByWidth(img) {
			const ratio = img.width / img.height;
			let canvas_width = 0;
			let canvas_height = 0;
			
			if (ratio >= 1) {
				if (img.width > MAX_SIZE) {
					canvas_width = MAX_SIZE;
					canvas_height = MAX_SIZE / ratio;
				} else {
					canvas_width = img.width;
					canvas_height = img.height;
				}
			} else {
				if (img.height > MAX_SIZE) {
					canvas_height = MAX_SIZE
					canvas_width = MAX_SIZE * ratio;
				} else {
					canvas_width = img.width;
					canvas_height = img.height;
				}
			}
			const canvas = document.createElement('canvas');
			canvas.width = canvas_width;
			canvas.height = canvas_height;
			const context = canvas.getContext('2d');
			context.drawImage(img,0,0, canvas_width, canvas_height);
			return canvas.toDataURL("image/jpeg");
		},
		_resizeByQuality(img, q) {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const context = canvas.getContext('2d');
			context.drawImage(img,0,0, img.width, img.height);
			return canvas.toDataURL("image/jpeg", q);
		},
	}
}
</script>

<style lang="scss" scoped>
.title {
	width: 100%;
	padding: 20px 40px;
}
.title-name {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 24px;
	line-height: 32px;
	color: #000000;
}
.title-desc {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	color: #82899B;
	span {
      text-decoration: underline;
    }
	&:hover {
		cursor: pointer;
	}
} 
.dropzone {
	height: 180px;
	margin: 0 20px;
	border: 3px dashed #00AAFD;
	border-radius: 4px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.dropzone-text {
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
}
.dropzone-drag {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #192A3E;
}
.dropzon-button {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.dropzon-button-sm {
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
}
.dropzone-file {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	text-decoration-line: underline;
	color: #00AAFD;
	&:hover {
		cursor: pointer;
	}
}

.dropzone-file-sm {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #00AAFD;
}
.dropzone-desc {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: rgba(25, 42, 62, 0.7);
	span {
		color: rgba(25, 42, 62, 0.9);
		font-weight: 500;
	}
}
.receipt-container {
	padding: 10px;
}
.receipt-container-item {
	margin: 10px;
	width: calc(100% - 20px);
	min-width: 0;
	max-width: 760px;
	height: 100%;
}
.hidden {
	display: none;
}
::v-deep {
	.v-label{
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 18px;
		color: #37495F;
	}
}
</style>
